import { element } from '@mkenzo_8/puffin'

const Documentation = () => {
	return element`
		<div>
			<h3>Documentation</h3>
			<p>Work in progress.</p>
		</div>
	`
}

export default Documentation